import { render, staticRenderFns } from "./courses.vue?vue&type=template&id=5c03d587&scoped=true"
import script from "./courses.vue?vue&type=script&lang=js"
export * from "./courses.vue?vue&type=script&lang=js"
import style0 from "./courses.vue?vue&type=style&index=0&id=5c03d587&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c03d587",
  null
  
)

export default component.exports